import requestor from "shared/service/requestor";

export default class ChapterApi {
  save = (courseId, form) => requestor.patch("/course/chapter_save", { course_id: courseId, CourseChapter: form });
}
